import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import mime from 'mime-types';
import _ from 'lodash';
import qs from 'qs';
import { Spinner } from '../common';

export default class FileField extends Component {
	
	constructor(props) {
		super(props);
		const filetypes = props.filetypes || '';
		this.state = { 
			files: props.input.value || [], 
			error: null, 
			acceptedFiles: [], 
			fileExts: filetypes.split(/,\s*/).map(e => `.${mime.extension(e)}`).join(', ')
		};
	}

	setFiles(nextFiles, prevFiles) {
		const files = _.union(nextFiles, prevFiles);
		this.setState({ files }, () => {
			this.props.input.onChange(this.state.files);
		});
	}

	setAcceptedFiles(nextFiles, prevFiles) {
		const acceptedFiles = _.union(nextFiles, prevFiles);
		this.setState({ acceptedFiles });
	}

	getSignedUpload(gcs, file, callback) {
		const { path, bucket, host, token } = gcs;
		const url = `${host}/v1/services/signed_upload_url`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${token}`
      },
      body: qs.stringify({ name: file.name, content_type: file.type, path, bucket })
    }).then((response) => {
      return response.json();
    }).then((json) => {
      callback(json.signed_url);
    }).catch((e) => {
      console.log(e);
    });
	}

	handleWithBase64(acceptedFiles) {
		const nextFiles = [];
		const { multiple } = this.props;
		acceptedFiles.forEach(f => {
			const reader = new FileReader();
			reader.onloadend = (e) => { 
				nextFiles.push(e.target.result);
				const prevFiles = multiple ? [...this.state.files] : [];
				this.setFiles(nextFiles, prevFiles);
			};
			
			reader.readAsDataURL(f);
		});
	}

	handleWithS3(acceptedFiles, s3) {
		const nextFiles = [];
		const { multiple } = this.props;
		acceptedFiles.forEach(f => {
			jQuery('.dropzone').toggleClass('sk-loading');
			const { url, fields } = s3;
			const data = new FormData();
			
			for (const [k, v] of Object.entries({ ...fields, 'Content-Type': f.type, file: f })) {
				data.append(k, v);
			}
			
			jQuery.ajax({ url, type: 'POST', contentType: false, processData: false, data })
			.then(r => {
				nextFiles.push(decodeURIComponent(jQuery(r).find('Location').text()));		
				const prevFiles = multiple ? [...this.state.files] : [];
				this.setFiles(nextFiles, prevFiles);
				jQuery('.dropzone').toggleClass('sk-loading');
			})
			.fail(e => console.log(e));
		});
	}

	handleWithGcs(acceptedFiles, gcs) {
		const nextFiles = [];
		const { multiple } = this.props;
		acceptedFiles.forEach(f => {
			jQuery('.dropzone').toggleClass('sk-loading');
			this.getSignedUpload(gcs, f, (url) => {
				fetch(url, {
		      method: 'PUT',
		      headers: {
		        'Content-Type': f.type,
		        'Access-Control-Allow-Origin': '*'
		      },
		      body: f
		    }).then((e) => {
		      nextFiles.push(e.url.split('?')[0]);		
					const prevFiles = multiple ? [...this.state.files] : [];
					this.setFiles(nextFiles, prevFiles);
		      jQuery('.dropzone').toggleClass('sk-loading');
		    }).catch((e) => {
		      console.log(e);
		    });
			});
		});
	}

	handleAccept(acceptedFiles) {
		this.setAcceptedFiles(acceptedFiles, this.state.acceptedFiles);
		const { s3, gcs } = this.props;
		if (s3) {
			return this.handleWithS3(acceptedFiles, s3);
		} else if (gcs) {
			return this.handleWithGcs(acceptedFiles, gcs);
		}
		return this.handleWithBase64(acceptedFiles);
	}

	handleReject() {
		const { maxSize } = this.props;
		this.setState({ 
			error: `Please check the filetype or filesize. Only files of max size ${maxSize / 1024000} MB and with extensions ${this.state.fileExts} are allowed.` 
		});
	}

	handleRemove(a) {
		let { files } = this.state;
		files.splice(a, 1);
		
		if (files.length === 0) {
			files = null;
		}

		this.setState({ files: files || [] }, () => {
			this.props.input.onChange(files);
			this.handleAcceptedFileRemove(a);
		});
	}

	handleAcceptedFileRemove(a) {
		let { acceptedFiles } = this.state;
		acceptedFiles.splice(a, 1);
		
		if (acceptedFiles.length === 0) {
			acceptedFiles = null;
		}

		this.setState({ acceptedFiles: acceptedFiles || [] });
	}

	renderFiles() {
		const { acceptedFiles } = this.state;
		return (
			<ul className="list-inline">
				{acceptedFiles.map((f, i) => {
					return (
						<li key={`file-${i}`} className="text-center">
							<p>{f.name}</p>
							<a href="javascript:void(0);" onClick={this.handleRemove.bind(this, i)}>Remove</a>
						</li>
					);
				})}
			</ul>
		);
	}


	render() {
		const { 
			input, 
			meta: { error, touched }, 
			label, 
			id,
			maxSize,
			minSize, 
			layout,
			multiple,
			filetypes,
			style
		} = this.props;

		const fullError = (this.state.error || error);
		const showError = fullError && (this.state.error || touched);
		
		const inputBlock = () => {
			return (
				<div>
					<div className='dropzone form-control spinkit'>
						<Spinner />
						<Dropzone
							onDropAccepted={this.handleAccept.bind(this)}
							onDropRejected={this.handleReject.bind(this)}
							style={style || {}}
							multiple={multiple || false}
							accept={filetypes || 'image/*'}
							maxSize={maxSize || 2097152}
							minSize={minSize || 1}
							ref={(node) => { this.dropzone = node; }}
						>
							<p className="text-center">
								Drag and drop files here, or click to select files to upload.<br /><br />
								Supported File Types: {this.state.fileExts} <br /><br />
								Max File Size: {maxSize / 1024000} MB
							</p>
						</Dropzone>
						{this.renderFiles()}
					</div>
					<FormControl.Feedback />
					<HelpBlock>{showError ? fullError : ''}</HelpBlock>
				</div>
			);
		};

		if (layout === 'horizontal') {
			return (
				<FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
					<Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
						{label}
					</Col>
					<Col xs={9}>
						{inputBlock()}
					</Col>
				</FormGroup>
			);
		}

		return (	
			<FormGroup 
				controlId={id || input.name} 
				className={label ? 'label-present' : 'label-blank'} 
				validationState={showError ? 'error' : null}
			>	
				{label ? <ControlLabel>{label}</ControlLabel> : ''}
				{inputBlock()}
			</FormGroup>
		);
	}
}
